import React from "react";

export default function PersonalPhoto({setImageAsFile}) {

  const handleImageAsFile = (e) => {
      const image = e.target.files[0]
      setImageAsFile(imageFile => (image))
  }
  return (
    <div>
      <h3>הוספת תמונה</h3>
      <div className="profile-update-labelinput-wrapper">
        <label className="profile-update-label" htmlFor="imageAsFile">
          העלאת תמונה מקצועית
        </label>
        <input
          className="profile-update-input"
          type="file"
          name="imageAsFile"
          id="imageAsFile"
          onChange={handleImageAsFile}
        />
      </div>
    </div>
  );
}
